import { useMemo } from "react";
import { useDashboardSummary } from "@/hooks/queries/useDashboardSummary";
import { useCaComposition } from "@/hooks/queries/useCaComposition";
import { useCaTrend } from "@/hooks/queries/useCaTrend";

interface GlobalAnalyticsParams {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function useGlobalAnalytics({ from, to, basis }: GlobalAnalyticsParams) {
  const params = useMemo(() => ({ from, to, basis }), [basis, from, to]);
  const { data: summary, isLoading: loadingSummary } = useDashboardSummary(params);
  const { data: composition, isLoading: loadingComposition } = useCaComposition(params);
  const { data: trend = [] } = useCaTrend(params);

  return {
    summary,
    composition,
    trend,
    loading: loadingSummary || loadingComposition,
  };
}
